/** GFG-388 (Collections Settings, GFG Admin) copy strings. */

export const COLLECTIONS_BACK_LABEL = "Collections";

export const COLUMN_LABELS = {
  collection: "COLLECTION",
  value: "VALUE",
  region: "REGION",
  products: "PRODUCTS",
  scope: "SCOPE",
  platform: "PLATFORM",
  synced: "SYNCED",
} as const;

export const CUSTOM_SWITCH_LOCKED_TITLE = "The Custom Collection is always internal";

export const ASSIGN_MODAL_TITLE = "Assign organization";
export const ASSIGN_HELPER_TEXT =
  "Type to search. Assigning makes this product available to add to the organization's collections.";
export const ORGANIZATION_LABEL = "Organization";
export const PRICE_TIER_LABEL = "Price tier";
export const PRICE_TIER_REQUIRED_ERROR = "Select a price tier";
export const SUGGESTED_TIER_HINT = "Suggested from the product's Shopify price.";
export const UNASSIGNED_LABEL = "Unassigned";

export const UNASSIGN_CONFIRM_TITLE = "Unassign product?";
export const unassignConfirmDescription = (productName: string, organizationName: string) =>
  `${productName} will be removed from ${organizationName}'s Campaign Builder. Campaigns already launched keep offering it to their recipients.`;

export const ASSIGN_SUCCESS_TOAST = "Organization assigned";
export const UNASSIGN_SUCCESS_TOAST = "Product unassigned";
export const platformEnabledToast = (name: string) => `${name} is now on the platform`;
export const platformDisabledToast = (name: string) => `${name} removed from the platform`;

export const LOAD_ERROR = "We couldn't load collections. Check your connection and try again.";
export const REFRESH_ERROR = "We couldn't refresh collections. Showing the last loaded list.";
export const LOAD_FALLBACK = "Could not load this collection.";
export const EMPTY_TEXT = "No products are mapped to this collection yet.";
export const COLLECTIONS_EMPTY_TITLE = "No collections found";
export const COLLECTIONS_EMPTY_TEXT = "There are no collections to show yet.";
export const TOGGLE_FALLBACK = "Could not update the platform setting.";
export const SAVE_FALLBACK = "Could not save the assignment.";
export const UNASSIGN_FALLBACK = "Could not unassign the product.";

export const RETRY_LABEL = "Retry";
export const LOADING_LABEL = "Loading…";
export const SAVE_LABEL = "Save";
export const CANCEL_LABEL = "Cancel";
export const CLOSE_LABEL = "Close";
export const UNASSIGN_LABEL = "Unassign";
export const TIER_PLACEHOLDER = "Choose a tier";
export const ORGANIZATION_SEARCH_PLACEHOLDER = "Search organizations";
export const organizationFallbackLabel = (organizationId: number) =>
  `Organization ${organizationId}`;
export const platformSwitchLabel = (name: string) => `Platform visibility for ${name}`;
